export const settingActionTypes = {
  CHANGE_THEME: 'CHANGE_THEME',
}

export const settingActions = {
  changeTheme: (payload, callback) =>
  ({
    type: settingActionTypes.CHANGE_THEME,
    payload,
    callback
  }),
};

export default settingActions;